import { css, keyframes, Theme } from '@emotion/react';
import { Flex, Grid } from 'components/box';
import { Heading } from 'components/typography';
import styled from 'components/styled';
import { Link } from 'components/configurable-routing';
import { REEL_DIGIT_HEIGHT } from './constants';

const gradientScroll = keyframes`
  from {
    background-position: 0% 50%;
  }
  to {
    background-position: 100% 50%;
  }
`;

/**
 * The gradient's end is a repetition of the start so we can have a seamless transition when the animation restarts.
 * Without this weird looping back on itself, we'll clearly be able to see the transition.
 */
const bhagGradient = (theme: Theme) => css`
  background: linear-gradient(
    90deg,
    ${theme.colors.lime} 0%,
    ${theme.colors.blue} 10%,
    ${theme.colors.purple} 20%,
    ${theme.colors.pink} 30%,
    ${theme.colors.yellow} 40%,
    ${theme.colors.orange} 50%,
    ${theme.colors.pink} 60%,
    ${theme.colors.purple} 70%,
    ${theme.colors.blue} 80%,
    ${theme.colors.lime} 90%,
    ${theme.colors.blue} 100%
  );
  background-size: 1000% 100%;
  animation: ${gradientScroll} 40s linear infinite;
`;

/**
 * The header's background gradient has a width of 105%, so in order for us to
 * match this background gradient seamlessly, we need to set the background size
 * to 105% as well.
 */
export const blueGradient = (palette: {
  start: string;
  middle: string;
  end: string;
}) =>
  `linear-gradient(to right, ${palette.start}, ${palette.middle}, ${palette.end});
  background-size: 105% 100%;
  `;

export const Separator = styled.span`
  font-weight: 900;
`;

export const ReelWindow = styled.span`
  display: inline-block;
  height: ${REEL_DIGIT_HEIGHT}em;
  overflow: hidden;
  vertical-align: top;
  line-height: ${REEL_DIGIT_HEIGHT};
`;

export const ReelStrip = styled.span`
  display: block;
  will-change: transform;
`;

export const ReelDigit = styled.span`
  display: block;
  height: ${REEL_DIGIT_HEIGHT}em;
  line-height: ${REEL_DIGIT_HEIGHT};
  font-weight: 900;
`;

export const CounterHeading = styled(Heading)`
  display: inline-flex;
  align-items: center;
  font-variant-numeric: tabular-nums;
`;

export const GradientSurface = styled(Flex)(
  ({ theme }) => css`
    ${bhagGradient(theme)};
    max-width: ${theme.maxGridWidth}px;
  `
);

export const GradientLink = styled(Link)(({ theme }) => bhagGradient(theme));

export const CounterGrid = styled(Grid)<{ withBackground?: boolean }>`
  ${({ withBackground, theme }) =>
    withBackground &&
    css`
      background: ${blueGradient(theme.gradientConfettiPalette.default)};
    `}
`;
